import { gate } from 'hub-http/gates';
export const CLEAR_CACHE_GATE = gate('persist-promise:clear-stale-data');